fourToldApp.controller("quentionsCntrl", function($scope, services, esb, $window, $controller, $location, $localStorage, $mdToast, $mdDialog, $httpParamSerializer, $routeParams, productService, theme) {
	$scope.progressCircular = undefined;

	var dataToPass = JSON.parse($window.localStorage.getItem('dataQuentions'));
	$window.localStorage.removeItem("dataQuentions");
    var isAuto = !dataToPass;
	if(dataToPass)
		$scope.isForAnswer = dataToPass.tipo == "answer";
	$scope.quentions = dataToPass;
	$scope.listAnswer = [];
	$scope.title = $scope.isForAnswer ? "Preguntas de seguridad" : "Configura tus preguntas de seguridad" ;
	$scope.theme = theme.getTheme();
	//$scope.progressCircular = true;
	var check_token;

	//request questions
	$scope.requestQuestions = function(token){
		$scope.progressCircular = false;
		$scope.quentions = services.configuration_securityQuentions('bearer ' + token).getQuestions({}, {},  function(response) {
			console.log(response);
		});
	};

	//message register succesfull
	$scope.toast = function(message) {
			$scope.progressEdit = undefined;
			$mdToast.show(
					$mdToast.simple()
					.textContent(message)
					.position('top')
					.action('Ok')
					.theme("info-toast")
					.hideDelay(0)
			);
	};

	if(isAuto && $window.sessionStorage.getItem('needConfigureQuestions') === 'true' && $window.localStorage.getItem('access_token1')){
			$scope.progressCircular = true;
			check_token = $window.localStorage.getItem('access_token1');
			$scope.requestQuestions($window.localStorage.getItem('access_token1'));
	}
	else if (isAuto && $window.sessionStorage.getItem("password") && $window.sessionStorage.getItem("prefix") && $window.sessionStorage.getItem("phoneNumber")) {
			$scope.toast("Registro realizado con exito");
			$scope.dialCode = $window.sessionStorage.getItem("prefix");
			$scope.username = $window.sessionStorage.getItem("phoneNumber");
			$scope.password = $window.sessionStorage.getItem("password");
			var registerTag = "";
			if($window.sessionStorage.getItem('registerTag')) {
					registerTag = "|" + $window.sessionStorage.getItem('registerTag')
			}

			var numeroTelf = $scope.dialCode + $scope.username.toString() + registerTag;
			var data = $httpParamSerializer({
					grant_type: "password",
					username: numeroTelf,
					password: $scope.password
			});
			$scope.progressCircular = true;
			var token = 'Basic ' + window.btoa("4told-fin-api:secret");
			services.login(token).login({}, data, function(response) {
					$scope.progressCircular = false;
					if(response.access_token){
						check_token = response.access_token;
						$scope.requestQuestions(response.access_token);
					} else alert(response.message);

			}, function(error) {
					alert("Ocurrio un error, intente de nuevo", "error-toast");
			})
	}

	//submit Answers
	$scope.submitAnswers = function(){
		$scope.progressCircular = true;
		for(var i= 0; i<$scope.quentions.data.length; i++){
			$scope.listAnswer[i] = {questionId: $scope.quentions.data[i].id, answer: $scope.quentions.data[i].answer}
		}

		if($scope.isForAnswer){
			services.configuration_securityQuentionsRequest('bearer ' + $window.localStorage.getItem('access_token1')).setAnswer({}, $scope.listAnswer,  function(response) {
				$scope.progressCircular = undefined;
				console.log(response);
				if(response.code === 1) {
					$window.sessionStorage.removeItem("needConfigureQuestions");
					$scope.hide({result:true});
				} else {
					$scope.hide({result:false, errorCode: response.code});
				}
			});

		} else {
			services.configuration_securityQuentions('bearer ' + check_token).setAnswer({}, $scope.listAnswer,  function(response) {
			$scope.progressCircular = true;
			if(response.code === 1){
				$window.sessionStorage.removeItem("needConfigureQuestions");
				if($window.localStorage.getItem('access_token1'))
					$location.path("/dashboard");
				else{
					$controller('loginCntrl', {
								$scope: $scope 
						});
						var registerTag = "";
						if($window.sessionStorage.getItem('registerTag') && $window.sessionStorage.getItem('registerTag') != "undefined" ) {
								registerTag =  $window.sessionStorage.getItem('registerTag')
						}
						$scope.submitTag(true, registerTag);
				}
			} else alert("submit Answers Error")
		});
		}
	};

  $scope.hide = function(ans) {
	$mdDialog.hide(ans);
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

});
